import {
  Card,
  CardContent,
} from "@/components/ui/card";
import { useAppStore } from "@/stores";
import useSWR from "swr";
import { getAll, getDeals, getDealstageAvgTimesByCompanyId } from "@/lib/supabase";
import { evaluateRiskForReview, prepareDealsForRiskAssessment } from "../lib/risk";
import { getAPI } from "@/lib/api";
import { Loader } from "@/components/Loader";
import { useLocation } from "wouter";
import { DealReviewDealsTable } from "./components";
import { usePostHog } from "@posthog/react";
import { usePageTimeTracking } from "@/lib/posthog/usePageTimeTracking";

export function RevenueIntelligenceDealReviewPage() {
  const { currentUser } = useAppStore((state) => state);
  const [_, setLocation] = useLocation();

  const posthog = usePostHog();
  usePageTimeTracking("deal_review", posthog);

  const {
    data: allOpenDeals,
    // error: allOpenDealsError,
    isLoading: isLoadingAllOpenDeals,
  } = useSWR(
    [
      'query:allOpenDeals',
      currentUser ? currentUser?.company_id.toString() : null,
    ],
    ([_, companyId]) => getDeals(companyId, {
      onlyOpen: true,
      nonZeroValue: true,
      includeEmails: true,
    }),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const {
    data: currencies,
    // error: currenciesError,
    isLoading: isLoadingCurrencies,
  } = useSWR(
    [
      'query:currencies',
      currentUser ? currentUser?.company_id.toString() : null,
    ],
    ([_, companyId]) => getAll("currencies", companyId),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  )

  const {
    data: pipelines,
    // error: pipelinesError,
    // isLoading: isLoadingPipelines,
  } = useSWR(
    [
      'query:pipelines',
      currentUser ? currentUser?.company_id.toString() : null,
    ],
    ([_, companyId]) => getAPI(`providers/hubspot/pipelines/${companyId}`),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  )

  const {
    data: dealstageAvgTimes,
    // error: dealstageAvgTimesError,
    // isLoading: isLoadingdealstageAvgTimes,
  } = useSWR(
    [
      'query:dealstageAvgTimes',
      currentUser ? currentUser?.company_id.toString() : null,
    ],
    ([_, companyId]) => companyId
      ? getDealstageAvgTimesByCompanyId(parseInt(companyId, 10))
      : [],
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  if (isLoadingCurrencies) return <Loader />;

  const hubspotDealsForReview = prepareDealsForRiskAssessment(
    allOpenDeals,
    pipelines,
    // @ts-ignore
    currencies,
    // @ts-ignore
    currentUser?.company,
    dealstageAvgTimes,
  );

  const {
    deals,
  } = evaluateRiskForReview(
    hubspotDealsForReview,
    currentUser?.company_id,
    pipelines?.results ?? [],
    dealstageAvgTimes ?? [],
  );

  return (
    <div className="space-y-4">
      <Card className="border-none bg-transparent">
        <CardContent className="px-0">
          <div className="flex flex-col gap-4">
            <div className="flex flex-row justify-between items-center">
              <h1>Deal Review</h1>
            </div>
          </div>

          <div className="py-4">
            {isLoadingAllOpenDeals ? (
              <Loader />
            ) : (
              <DealReviewDealsTable
                deals={deals ?? []}
                onClickDeal={(dealId) => setLocation(`/revenue-intelligence/deal/${dealId}`)}
              />
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

